module.exports = __webpack_public_path__ + "static/media/Front.fbb8c9d7.webp";